import { Notification } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import React from "react";
import { connect } from "react-redux";
import { IRootState } from "../store";

const SuccessMessage: React.FC<any> = ({ successMessage }: { successMessage: { show: boolean; text: string } }) => (
  <>
    {successMessage.text !== "" && (
      <Notification
        styles={{
          icon: {
            color: "#FFFFFF",
            backgroundColor: "#16A34A",
            borderRadius: 999,
            padding: 4,
          },
          root: {
            border: "1px solid #16A34A",
            backgroundColor: "#DCFCE7",
          },
          title: {
            color: "#14532D",
            fontWeight: 800,
          },
          description: {
            color: "#14532D",
          },
        }}
        style={{
          position: "fixed",
          bottom: 0,
          right: 0,
          margin: "25px",
          zIndex: 10000000,
        }}
        withBorder={true}
        withCloseButton={false}
        icon={<IconCheck />}
        title={"Utført!"}
      >
        {successMessage.text?.split("\n").map((row: string, i: number) => (
          <div key={i}>{row}</div>
        ))}
      </Notification>
    )}
  </>
);

const mapStateToProps = (state: IRootState) => ({
  successMessage: state.globalReducer.successMessage,
});

export default connect(mapStateToProps, {})(SuccessMessage);
